import styled, { css } from "styled-components";

export const PartnersListScroll = styled.div(
    () => css`
        max-height: 275px;
        overflow-y: scroll;

        ::-webkit-scrollbar-track {
            background: white;
            border-radius: 4px;
        }

        ::-webkit-scrollbar-thumb {
            background: #ededed;
            border-radius: 4px;
        }

        .list-wrapper {
            padding-right: 5px;
        }

        .list-wrapper .partner-option:not(:last-child) {
            border-bottom: 1px solid #00000029;
            color: #707070;
        }

        .infinite-list {
            row-gap: 0px !important;
        }
    `,
);
